import { SLICER_KEYS } from 'types/services';
import type { Slicers } from 'types/services';

export const selectComponentHeight = (id: string) => (state: Slicers) => {
  return state[SLICER_KEYS.UI_STATE].componentHeights[id];
};

export const selectComponentPadding = (id: string) => (state: Slicers) => {
  return state[SLICER_KEYS.UI_STATE].componentPaddings[id];
};

export const selectUiState = () => (state: Slicers) => {
  return state[SLICER_KEYS.UI_STATE];
};
